import { ADD_LINE, ADD_LINE_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const addLineAction = (params) => async (dispatch) => {
  const { legal_id, order_id, direct_number } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}/lines`,
      {
        direct_number,
      },
    );

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || {},
      type: ADD_LINE,
    });
  } catch (e) {
    dispatch({
      method: 'post',
      payload: e || {},
      type: ADD_LINE_ERROR,
    });
  }
};
